import { Experiment } from '../newtab/features/user/slice/types';
import { setOhCookies } from './cookie';
import { getOS } from './index';

export const syncRemoteConfig = async ({
  experiment,
  installationDate
}: { experiment: Experiment, installationDate: number }): Promise<Experiment> => {
  const os = await getOS();

  const uRLSearchParams = new URLSearchParams({
    platform: 'EXTENSION',
    version: process.env.APP_VERSION,
    appType: process.env.APP_TYPE,
    appPlatform: process.env.APP_PLATFORM,
    os,

    ...(experiment &&
      experiment.scenario &&
      experiment.experimentId && {
      experimentId: experiment.experimentId,
      scenarioId: experiment.scenario.id
    }),
    installationDate: String(installationDate),
  });
  const url = `${process.env.APP_URL}/api/remote-config?${uRLSearchParams}`;
  // console.log('url', url);
  try {
    const experiment = await fetch(url).then((response) =>
      response.ok ? response.json() : null
    );
    if (!experiment || !experiment.scenario) return null;

    setOhCookies(
      'extensionExperimentName',
      experiment && experiment.scenario ? experiment.scenario.name : ''
    );
    // console.log('experiment', experiment);
    return experiment;
  } catch (err) {
    console.error('FETCH /remote-config', err);
  }
};
